import { useQuery } from '@tanstack/react-query';

import { getAffiliationList } from '~/services/AgentHub/AgentService';

const FIVE_MINUTES = 5 * 60 * 1000;

interface UseGetAffiliationListOptions {
  enabled?: boolean;
}

export function useGetAffiliationList(regionCode?: string, options: UseGetAffiliationListOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: ['affiliation-list', regionCode],
    queryFn: async () => {
      return await getAffiliationList(regionCode);
    },
    enabled,
    staleTime: FIVE_MINUTES,
  });
}
